/** Размер изображения в пикселях. */
export interface ImageSize {
  width: number;
  height: number;
}

export enum TranslationBlocks {
  MainPage = 'dev_main',
  HeaderAndFooter = 'dev_header_footer',
  ApiSdk = 'dev_api_sdk',
  MobileSdk = 'deb_mobile_sdk',
  CityScan = 'dev_lens',
  ApiMap = 'dev_api_map',
  Partners = 'dev_partners',
  Print = 'dev_print',
  Company = 'dev_company',
  ApiNav = 'dev_api_nav',
  Government = 'dev_government',
  Onprem = 'dev_onprem',
  ApiSearch = 'dev_api_search',
  Db = 'dev_db',
  Business = 'dev_bussiness',
  Vectormaps = 'dev_vectormaps',
  Pro = 'dev_pro',
  Cases = 'dev_cases',
  CasesAnalyseApk = 'dev_cases_analyse_apk',
  CasesAnalysisDevelopmentDynamics = 'dev_cases_analysis_development_dynamics',
  CasesBarbershop2GisPro = 'dev_cases_barbershop_2gispro',
  CasesCafe2GisPro = 'dev_cases_cafe_2gispro',
  CasesDashboard = 'dev_cases_dashboard',
  CasesDigitalTwinNalchikGovernment = 'dev_cases_digitaltwin_nalchik_government',
  CasesGeoanalyticsGasStation = 'dev_cases_geoanalytics_gas_station',
  CasesGeorgianRestaurant2GisPro = 'dev_cases_georgian_restaurant_2gispro',
  CasesMegaptekaApi = 'dev_cases_megapteka_api',
  CasesMobileResearch = 'dev_cases_mobile_research',
  CasesRoadsSafety = 'dev_cases_roads_safety',
  CasesSmeGovernment = 'dev_cases_sme_government',
  PlatformManager = 'dev_platform_manager',
  Geoflow = 'dev_geoflow',
  Indoor = 'dev_indoor',
  Geocoder = 'dev_geocoder',
  RasterTiles = 'dev_raster_tiles',
  StaticAPI = 'dev_static_api',
  PlacesAPI = 'dev_places_api',
  SuggestAPI = 'dev_suggest_api',
  MatrixAPI = 'dev_matrix_api',
  MapMatchingAPI = 'dev_map_matching_api',
  RoutingAPI = 'dev_routing_api',
  DataCompany = 'dev_data_company',
  MapTiles = 'dev_map_tiles',
  RadarAPI = 'dev_radar_api',
  RoutePlanner = 'dev_route_planner',
  News = 'dev_news',
  IsochroneAPI = 'dev_isochrone_api',
  Logistics = 'dev_geoflow_logistics',
  Mcp = 'dev_mcp',
  ApiLogistics = 'dev_api_logistics',
  PromoAwardsWinners = 'promo_awards_winners',
  PromoCompanyDatabasesDiscount = 'promo_company_databases_discount',
  MapStyleEditor = 'dev_map_style_editor',
  /** Общие переводы, повторяющиеся на нескольких страницах. Не является страницей. */
  Common = 'dev_common',
}

export const PAGES_TO_PATHS: Record<string, string> = {
  [TranslationBlocks.MainPage]: '/',
  [TranslationBlocks.ApiSdk]: '/api',
  [TranslationBlocks.MobileSdk]: '/api/mobile-sdk',
  [TranslationBlocks.Cases]: '/cases',
  [TranslationBlocks.CasesAnalyseApk]: '/cases/analyse_apk',
  [TranslationBlocks.CasesAnalysisDevelopmentDynamics]:
    '/cases/analysis_development_dynamics',
  [TranslationBlocks.CasesBarbershop2GisPro]: '/cases/barbershop_2gispro',
  [TranslationBlocks.CasesCafe2GisPro]: '/cases/cafe_2gispro',
  [TranslationBlocks.CasesDashboard]: '/cases/dashboard',
  [TranslationBlocks.CasesDigitalTwinNalchikGovernment]:
    '/cases/digitaltwin_nalchik_government',
  [TranslationBlocks.CasesGeoanalyticsGasStation]:
    '/cases/geoanalytics_gas_station',
  [TranslationBlocks.CasesGeorgianRestaurant2GisPro]:
    '/cases/georgian_restaurant_2gispro',
  [TranslationBlocks.CasesMegaptekaApi]: '/cases/megapteka_api',
  [TranslationBlocks.CasesMobileResearch]: '/cases/mobile_research',
  [TranslationBlocks.CasesRoadsSafety]: '/cases/roads_safety',
  [TranslationBlocks.CasesSmeGovernment]: '/cases/sme_government',
  [TranslationBlocks.Government]: '/government',
  [TranslationBlocks.Onprem]: '/onpremise',
  [TranslationBlocks.ApiSearch]: '/api/catalog',
  [TranslationBlocks.Db]: '/data',
  [TranslationBlocks.Business]: '/bussiness',
  [TranslationBlocks.Vectormaps]: '/vectormaps',
  [TranslationBlocks.Pro]: '/pro',
  [TranslationBlocks.Print]: '/print',
  [TranslationBlocks.Company]: '/company',
  [TranslationBlocks.ApiNav]: '/api/routing',
  [TranslationBlocks.Partners]: '/partners',
  [TranslationBlocks.CityScan]: '/cityscan',
  [TranslationBlocks.ApiMap]: '/api/map',
  [TranslationBlocks.Geoflow]: '/geoflow',
  [TranslationBlocks.Logistics]: '/2gis-geoflow-logistics',
  [TranslationBlocks.Indoor]: '/api/map/indoor',
  [TranslationBlocks.Geocoder]: '/api/geocoder',
  [TranslationBlocks.RasterTiles]: '/api/raster-tiles',
  [TranslationBlocks.StaticAPI]: '/api/static-api',
  [TranslationBlocks.PlacesAPI]: '/api/places-api',
  [TranslationBlocks.SuggestAPI]: '/api/suggest-api',
  [TranslationBlocks.MatrixAPI]: '/api/matrix-api',
  [TranslationBlocks.RoutingAPI]: '/api/routing-api',
  [TranslationBlocks.MapMatchingAPI]: '/api/map-matching',
  [TranslationBlocks.DataCompany]: '/data-company',
  [TranslationBlocks.MapTiles]: '/api/map-tiles',
  [TranslationBlocks.RadarAPI]: '/api/radar-api',
  [TranslationBlocks.RoutePlanner]: '/api/route-planner',
  [TranslationBlocks.News]: '/news',
  [TranslationBlocks.IsochroneAPI]: '/api/isochrone-api',
  [TranslationBlocks.Mcp]: '/api/mcp',
  [TranslationBlocks.ApiLogistics]: '/api/logistics',
  [TranslationBlocks.PromoAwardsWinners]: 'promo/award-winners',
  [TranslationBlocks.PromoCompanyDatabasesDiscount]:
    'promo/company-databases-discount',
  [TranslationBlocks.MapStyleEditor]: '/api/map-style-editor',
};

export type Locale = 'ru' | 'en' | 'kz' | 'am' | 'ge' | 'tg';
export type Domain = 'ru' | 'com' | 'kz' | 'am' | 'ge' | 'tj';

export type DomainLocaleConfig = Record<
  Domain,
  Partial<Record<Locale, string>>
>;

export interface TranslatedComponent {
  translations: Record<string, string>;
}

export interface TranslationResponseData {
  id: number;
  name: string;
  text: string;
  page: string;
}

export interface LocalizedPageProps {
  params: Promise<{
    locale: Locale;
  }>;
}

/** Параметры страниц, статически формируемых для каждой пары локаль × домен. */
export interface DomainLocalizedPageProps {
  params: Promise<{
    domain: Domain;
    locale: Locale;
  }>;
}

export enum Industry {
  Business = 'business',
  Government = 'government',
  Catering = 'catering',
  RealEstate = 'real-estate',
  ECommerce = 'e-commerce',
  Retail = 'retail',
  Beauty = 'beauty',
  Logistics = 'logistics',
  Agroprom = 'agroprom',
  OilProduction = 'oil-production',
  Transport = 'transport',
}

export const industryLabels: Record<Industry, string> = {
  [Industry.Business]: 'Бизнес',
  [Industry.Government]: 'Госсектор',
  [Industry.Catering]: 'Общепит',
  [Industry.RealEstate]: 'Недвижимость',
  [Industry.ECommerce]: 'E-commerce',
  [Industry.Retail]: 'Ритейл',
  [Industry.Beauty]: 'Индустрия красоты',
  [Industry.Logistics]: 'Логистика',
  [Industry.Agroprom]: 'Агропром',
  [Industry.OilProduction]: 'Нефтедобыча',
  [Industry.Transport]: 'Транспорт',
};

export type Translations = Record<string, string>;

export enum Product {
  ImmersiveMaps = 'immersive-maps',
  MapsAPI = 'maps-api',
  MobileSDK = 'mobile-sdk',
  Databases = 'databases',
  ApiSdk = 'api-sdk',
  VectorMaps = 'vector-maps',
  Pro = 'pro',
  CustomSolutions = 'custom-solutions',
}

export const productLabels: Record<Product, string> = {
  [Product.ImmersiveMaps]: 'Иммерсивные карты',
  [Product.MapsAPI]: 'API карт',
  [Product.MobileSDK]: 'Mobile SDK',
  [Product.Databases]: 'Базы данных',
  [Product.ApiSdk]: 'API и SDK',
  [Product.VectorMaps]: 'Векторные карты',
  [Product.Pro]: '2ГИС Про',
  [Product.CustomSolutions]: 'Индивидуальные решения',
};
